// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__hfTA7","label":"Labeled_label__6u0dw","divider":"Labeled_divider__2eoaa"};